import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Editors from "@/pages/Editors";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import History from "@/pages/History";
import SettingsPage from "@/pages/Settings";
import Annotator from "@/pages/Annotator";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/projects/:projectId/versions/:versionId/annotate" element={<Annotator />} />
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Dashboard />} />
                        <Route path="editors" element={<Editors />} />
                        <Route path="projects" element={<Projects />} />
                        <Route path="projects/:id" element={<ProjectDetail />} />
                        <Route path="history" element={<History />} />
                        <Route path="settings" element={<SettingsPage />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
